import React from 'react';
import { UserStats } from '../../types/math';
import { Flame, Award, CheckCircle, Volume2, VolumeX } from 'lucide-react';

interface ScoreStreakProps {
  stats: UserStats;
  isMuted: boolean;
  onToggleSound: () => void;
}

export const ScoreStreak: React.FC<ScoreStreakProps> = ({
  stats,
  isMuted,
  onToggleSound
}) => {
  const accuracy = stats.totalAnswered > 0
    ? Math.round((stats.correctAnswered / stats.totalAnswered) * 100)
    : 100;

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 bg-slate-900/80 border border-slate-800/80 px-4 py-2.5 rounded-xl backdrop-blur-md">
      <div className="flex items-center gap-4 sm:gap-6">
        {/* Streak */}
        <div className={`flex items-center gap-1.5 font-mono ${stats.streak >= 3 ? 'text-amber-400 font-bold' : 'text-slate-300'}`}>
          <Flame className={`w-5 h-5 ${stats.streak >= 3 ? 'text-amber-400 fill-amber-400 animate-pulse' : 'text-slate-500'}`} />
          <span className="text-sm">
            Streak: <span className="text-base text-white">{stats.streak}</span>
          </span>
        </div>

        {/* Max Streak */}
        <div className="hidden sm:flex items-center gap-1.5 font-mono text-xs text-slate-400">
          <Award className="w-4 h-4 text-purple-400" />
          <span>Best: <span className="text-slate-200">{stats.maxStreak}</span></span>
        </div>

        {/* Accuracy */}
        <div className="flex items-center gap-1.5 font-mono text-xs text-slate-400">
          <CheckCircle className="w-4 h-4 text-teal-400" />
          <span>
            Accuracy: <span className="text-slate-200 font-semibold">{accuracy}%</span>{' '}
            <span className="text-slate-500">({stats.correctAnswered}/{stats.totalAnswered})</span>
          </span>
        </div>
      </div>

      {/* Audio Mute Switch */}
      <button
        onClick={onToggleSound}
        title={isMuted ? 'Unmute Sound' : 'Mute Sound'}
        className="p-1.5 rounded-lg bg-slate-800/80 hover:bg-slate-700/80 text-slate-300 hover:text-white transition flex items-center gap-1.5 text-xs font-mono"
      >
        {isMuted ? (
          <>
            <VolumeX className="w-4 h-4 text-rose-400" />
            <span className="hidden md:inline">Muted</span>
          </>
        ) : (
          <>
            <Volume2 className="w-4 h-4 text-teal-400" />
            <span className="hidden md:inline">Audio On</span>
          </>
        )}
      </button>
    </div>
  );
};
